const { trackMetric } = require('../collector');
const { supportsNavigatorApi } = require('../support');
const { RAM_SIZE, CPU_CORES } = require('../../constants/metrics');

const deviceInformationMonitor = () => {
  if (supportsNavigatorApi()) {
    if (window.navigator.deviceMemory) {
      trackMetric(RAM_SIZE, `${window.navigator.deviceMemory}`);
    }
    if (window.navigator.hardwareConcurrency) {
      trackMetric(CPU_CORES, `${window.navigator.hardwareConcurrency}`);
    }
  }
};

module.exports = deviceInformationMonitor;
